import React from 'react';
import { PdfIndex } from '../../Canvas/PdfFormat'
import { TratoFormatIndex } from '../../Canvas/TratoFormat'
import { useEditorState, useEditorActions } from '../../editor-context'


export function DocumentIndex() {
    const { document: doc, currentPage, documentType } = useEditorState()
    const { setCurrentPage } = useEditorActions()

    const handlePageClick = (page) => {
        setCurrentPage(page)
    }

    return (
        <div className="sidebar-content">
            { documentType === 'pdf' ? <PdfIndex 
                url={doc.importedPdf}
                currentPage={currentPage}
                width={200}
                onPageClick={handlePageClick}
            /> : <TratoFormatIndex /> }
        </div>

    )
}